import { useContext } from "react";
import { InterviewQuestionAIVideoContext } from "components/Missions/Roles/InterviewQuestionAIVideo/InterviewQuestionAIVideoContext";

export default function useInterviewQuestionAIVideoContext() {
  const context = useContext(InterviewQuestionAIVideoContext);

  if (!context) {
    throw new Error("useInterviewQuestionAIVideoContext must be used within InterviewQuestionAIVideoProvider");
  }

  return context;
}
